import React from "react";
import Tabs from "../../components/common/Tabs";
import { StoreInventoryMenu } from "../../utils/constants";
import StoreSidebarToggle from "../../components/Store/StoreSidebarToggle";

const StoreInventory = () => {
  return (
    <>
      <main>
        <div className="flex items-center mb-4">
          <Tabs tabs={StoreInventoryMenu} prefix={<StoreSidebarToggle />} />
        </div>
      </main>
    </>
  );
};

export default StoreInventory;
